import { render } from "./VUEPopupColoriGraficaCatena.vue?vue&type=template&id=550ee4ad"
import script from "./VUEPopupColoriGraficaCatena.vue?vue&type=script&lang=js"
export * from "./VUEPopupColoriGraficaCatena.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__